import { useQuery } from 'react-query';
import { TagQueryOptions, GetParams, TagPaginator, Tag } from '@/types';
import { mapPaginatorData } from './utils/data-mapper';
import { API_ENDPOINTS } from './client/endpoints';
import client from '@/data/client';

export const useTagQuery = ({ slug, language }: GetParams) => {
  const { data, error, isLoading } = useQuery<Tag, Error>(
    [API_ENDPOINTS.TYPES, { slug, language }],
    () => client.tags.get({ slug, language })
  );
  return {
    tag: data,
    error,
    loading: isLoading,
  };
};

export const useTagsQuery = (options: Partial<TagQueryOptions>) => {
  const { data, error, isLoading } = useQuery<TagPaginator, Error>(
    [API_ENDPOINTS.TAGS, options],
    ({ queryKey, pageParam }) =>
      client.tags.all(Object.assign({}, queryKey[1], pageParam)),
    {
      keepPreviousData: true,
    }
  );

  return {
    tags: data?.data ?? [],
    paginatorInfo: mapPaginatorData(data),
    error,
    loading: isLoading,
  };
};
